// src/components/ActionButtons.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings, HelpCircle, Utensils, Dice5 } from 'lucide-react';

function ActionButtons() {
    const navigate = useNavigate();

    const actions = [
        { label: 'Cardápio', icon: Utensils, route: '/cardapio', color: 'text-[#971253]' },
        { label: 'Acervo de Jogos', icon: Dice5, route: '/biblioteca', color: 'text-[#528a89]' },
        { label: 'Dúvidas', icon: HelpCircle, route: '/faq', color: 'text-stone-500' },
        { label: 'Ajustes', icon: Settings, route: '/usuario', color: 'text-stone-500' },
    ];

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {actions.map((action, idx) => (
                <button 
                    key={idx}
                    onClick={() => navigate(action.route)}
                    className="flex flex-col items-center justify-center p-5 bg-white rounded-2xl border border-[#dbcdac]/40 hover:border-[#dbcdac] hover:shadow-md transition-all group"
                >
                    <action.icon size={28} strokeWidth={1.5} className={`${action.color} mb-3 group-hover:scale-110 transition-transform duration-300`} />
                    <span className="text-sm font-bold text-stone-700 tracking-wide">{action.label}</span>
                </button>
            ))}
        </div>
    );
}

export default ActionButtons;